import { render, staticRenderFns } from "./CancellationPolicy.vue?vue&type=template&id=3866a64a&scoped=true&"
import script from "./CancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./CancellationPolicy.vue?vue&type=script&lang=js&"
import style0 from "./CancellationPolicy.vue?vue&type=style&index=0&id=3866a64a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3866a64a",
  null
  
)

export default component.exports